/*
 * AiQuotaInline — compact, inline-on-the-action quota indicator + banner.
 *
 * Use it right next to the "Generate" button on each SEO tab:
 *
 *   <AiQuotaInline quota={quota} reached={reached} />
 *   <Button disabled={generating || reached} ...>...</Button>
 *
 * Source of truth is the backend; this component is UX only.
 */

import { useLanguage } from '@/contexts/LanguageContext';
import { quotaWarningLevel } from '@/lib/aiQuota';
import { BuyExtraCreditsButton } from '@/components/BuyExtraCreditsButton';

export function AiQuotaInline({ quota }) {
  const { language } = useLanguage();
  const t = (fr, en) => language === 'fr' ? fr : en;

  if (!quota || quota.total <= 0) return null;

  const level = quotaWarningLevel(quota.used, quota.total);
  const reached = level === 'reached';

  return (
    <div className="space-y-1.5" data-testid="ai-quota-inline">
      <div className={`text-xs ${reached ? 'text-destructive font-medium' : 'text-muted-foreground'}`}>
        {t('Générations IA :', 'AI generations:')} <span className="font-mono tabular-nums">{quota.used} / {quota.total}</span> {t('utilisées ce mois-ci', 'used this month')}
      </div>
      {reached && (
        <div
          className="text-xs p-2 rounded-md border border-destructive/40 bg-destructive/5 text-destructive space-y-2"
          data-testid="ai-quota-reached-banner"
        >
          <div>
            {t(
              'Limite IA atteinte pour ce mois. Passez au forfait supérieur ou achetez des crédits supplémentaires.',
              'AI limit reached for this month. Upgrade your plan or buy extra credits.'
            )}
          </div>
          <BuyExtraCreditsButton quota={quota} variant="default" size="sm" />
        </div>
      )}
    </div>
  );
}
